String.prototype.toCapitalCase = function() {
    return this.split(' ').map((word) => {
        return word.charAt(0).toUpperCase() + word.substr(1)
    }).join(' ')
}


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import dataStore from './stores/dataStore'

Vue.config.productionTip = false

window.vueApp = new Vue({
    router,
    data: dataStore.data,
    methods: dataStore.methods,
    computed: dataStore.computed,
    created: dataStore.created,
    render: h => h(App)
}).$mount('#app')
